import { useComponentTranslation } from '@core/i18n'
import { useCallback } from 'react'

import { useToast } from '../../toast-card'
import { ToastOptions } from '../../toast-card/Toasts.types'
import { useDeliveryAlreadyPickingBottomSheet } from '../components/delivery-already-picking-bottom-sheet/delivery-already-picking-bottom-sheet'
import { ShopperIdentificationError } from '../set-identification.types'

export const useFeedbackToast = () => {
  const t = useComponentTranslation('SetIndentification')
  const { toast } = useToast()
  const { openDeliveryAlreadyPicking } = useDeliveryAlreadyPickingBottomSheet()

  //TODO: Adicionar código aos erros para padronização dos toasts - TTS-2278
  const onErrorFeedback = useCallback(
    (message: string) => {
      const errorMessages: Record<
        ShopperIdentificationError,
        ToastOptions | (() => void)
      > = {
        [ShopperIdentificationError.SHOPPER_NOT_FOUND]: {
          title: t('ID not found'),
          description: t('Please check your ID and try again'),
        },
        [ShopperIdentificationError.BAD_REQUEST]: {
          title: t('ID not found'),
          description: t('Please check your ID and try again'),
        },
        [ShopperIdentificationError.DELIVERY_NOT_FOUND]: {
          title: t('Order not found'),
          description: t('Check the order and try again'),
        },
        [ShopperIdentificationError.CHECKING_NOT_FOUND]: {
          title: t('Checking not found'),
        },
        [ShopperIdentificationError.MOVEMENT_NOT_OPEN]: {
          title: t('Movement not open'),
        },
        [ShopperIdentificationError.INVALID_STATUS_TRANSITION]: {
          title: t('Invalid status transition'),
        },
        [ShopperIdentificationError.FAILED_TO_ASSIGN_SHOPPER]: {
          title: t('Failed to assign shopper'),
        },
        [ShopperIdentificationError.DELIVERY_ALREADY_PICKING]:
          openDeliveryAlreadyPicking,
        [ShopperIdentificationError.PICKING_ALREADY_ASSIGNED]:
          openDeliveryAlreadyPicking,
      }

      const getErrorMessage = (
        errorMessage: string
      ): ToastOptions | (() => void) => {
        const matchedMessage = Object.keys(errorMessages).find((key) =>
          errorMessage.includes(key)
        ) as ShopperIdentificationError | undefined

        return matchedMessage
          ? errorMessages[matchedMessage]
          : {
              title: t('Unexpected error', { error: errorMessage }),
            }
      }

      const feedbackMessage = getErrorMessage(message)

      if (typeof feedbackMessage === 'function') {
        feedbackMessage()
        return
      }

      toast.error({
        position: 'top',
        ...feedbackMessage,
      })
    },
    [openDeliveryAlreadyPicking, t, toast]
  )

  return { onErrorFeedback }
}
